import { forwardRef } from 'react';
import { Button } from 'react-bootstrap';
import { BiCheck, BiPencil, BiTrash, BiX } from 'react-icons/bi';

type TipoAcaoLinha = 'editar' | 'excluir' | 'salvar' | 'cancelar';

const ACOES = {
  editar: { variant: 'outline-primary', Icon: BiPencil, label: 'Editar' },
  excluir: { variant: 'outline-danger', Icon: BiTrash, label: 'Excluir' },
  salvar: { variant: 'success', Icon: BiCheck, label: 'Salvar' },
  cancelar: { variant: 'outline-secondary', Icon: BiX, label: 'Cancelar' },
} as const;

type Props = {
  tipo: TipoAcaoLinha;
  onClick: () => void;
};

export const BotaoAcaoLinha = forwardRef<HTMLButtonElement, Props>(function BotaoAcaoLinha(
  { tipo, onClick },
  ref,
) {
  const { variant, Icon, label } = ACOES[tipo];
  return (
    <Button
      ref={ref}
      type="button"
      variant={variant}
      size="sm"
      className="d-inline-flex align-items-center gap-1 px-2 py-1 lh-1"
      style={{ borderRadius: '6px' }}
      onClick={onClick}
      title={label}
    >
      <Icon size={14} aria-hidden />
      {label}
    </Button>
  );
});
